var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGr = function SvgGr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 8.87h11.587a11.932 11.932 0 0 0-1.348-3.13H12v3.13ZM4.53 21.391h14.94a12.06 12.06 0 0 0 2.77-3.13H1.761a12.064 12.064 0 0 0 2.769 3.13ZM4.174 2.904a12.059 12.059 0 0 0-2.412 2.835h2.412V2.904ZM12 12V8.87H7.304V12h-3.13V8.87H.414A12.013 12.013 0 0 0 0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 0c-1.666 0-3.253.34-4.695.954V5.74H12V2.61h7.47A11.949 11.949 0 0 0 12 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGr;